const timeStampGenerator = () => {
    const timeZone = "Etc/GMT+5";
    const dateInUtcMinus11 = new Date().toLocaleString("en-US", { timeZone });
  
    return dateInUtcMinus11;
  };
  export default timeStampGenerator;
  